module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia3-b45ffc6e4353c9e54a6d1cae6c3a82c5.jpg";